import React, { useRef, useState, useEffect, useContext } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import send from "../../Assets/Images/send.png";
import axios from "axios";
import {
  showToast,
  WEBSERVICE,
  checkCurrencyPairAccreditedStatus,
} from "../../CoreDataService";
import { useNavigate } from "react-router-dom";
import InfoPopUp from "../../Common/InfoPopUp";
import { DataContext } from ".";
import TelegramIcon from "@mui/icons-material/Telegram";
import InfoIcon from "@mui/icons-material/Info";
import AccreditationVerificationPopup from "../Accredited-Kyc/AccreditationVerificationPopup";
import TermsAgreementPopup from "../Accredited-Kyc/TermsAgreementPopup";
import { showErrorDialog } from "../../CoreDataService";

const title = "Market";
const description = `Users can Buy and Sell in the current market price. Enter "Buying
              Amount" and click on BUY to place a BUY Market order. Enter
              "Selling Amount" and click on SELL to place a SELL Market order.`;

const BuyAndSellIOC = ({
  selectedBuyingAssetBalance,
  selectedSellingAssetBalance,
  percentageValue,
  selectedOrderType,
  getUserTransaction,
  minBuySellAmount,
}) => {
  const { currencycode, basecurrency, ltp } = useContext(DataContext);
  const theme = localStorage.getItem("theme");
  const tradep = localStorage.getItem("priceprc") || 6;
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [progress, setProgress] = useState(0);
  const progressBarRef = useRef(null);
  const [sliderValue, setSliderValue] = useState(0);
  const sliderRef = useRef(null);
  const steps = [0, 25, 50, 75, 100];
  const [isLoading, setIsLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [stpLoader, setStpLoader] = useState(false);
  const handleClose = () => setShow(false);

  const [limitAmount, setLimitAmount] = useState("");
  const [limitPrice, setLimitPrice] = useState("");
  const [limitValue, setLimitValue] = useState("");
  const [error, setError] = useState(false);
  const [limitPriceSell, setLimitPriceSell] = useState("");
  const [limitAmountSell, setLimitAmountSell] = useState("");
  const [limitValueSell, setLimitValueSell] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const [loading, setLoading] = useState(false);

  const [spotMyOfferData, setSpotMyOfferData] = useState();
  const [spotSpotLimitBuyData, setSpotSpotLimitBuyData] = useState();
  const [spotSpotLimitSellData, setSpotSpotLimitSellData] = useState();
  const [showAccreditedPopup, setShowAccreditedPopup] = useState(false);
  const [showTermsPopup, setShowTermsPopup] = useState(false);
  const [termsLinks, setTermsLinks] = useState([]);
  const [pendingProceed, setPendingProceed] = useState(null);
  const [pendingTxnType, setPendingTxnType] = useState(null);

  const getAssetCode = (counter, base) => {
    try {
      const assets = JSON.parse(localStorage.getItem("spot_assets")) || [];

      const asset = assets.find(
        (item) =>
          counter.toUpperCase() === item.currencyCode.toUpperCase() &&
          base.toUpperCase() === item.baseCurrency.toUpperCase()
      );

      return asset ? asset.assetCode : "";
    } catch (error) {
      console.error("Error parsing spot_assets:", error);
      return "";
    }
  };

  useEffect(() => {
    setLimitPrice("");
    setLimitAmount("");
    setLimitValue("");
    setProgress(0);
    setLimitAmountSell("");
    setLimitPriceSell("");
    setLimitValueSell("");
    setSliderValue(0);
  }, [selectedOrderType]);

  /* Get base and counter ID of a pair */
  const getAssetId = (counter, base) => {
    try {
      const assets = JSON.parse(localStorage.getItem("spot_assets")) || [];

      const asset = assets.find(
        (item) =>
          counter.toUpperCase() === item.currencyCode.toUpperCase() &&
          base.toUpperCase() === item.baseCurrency.toUpperCase()
      );

      return asset
        ? { baseCurrencyId: asset.baseCurrencyId, currencyId: asset.currencyId }
        : {};
    } catch (error) {
      console.error("Error parsing spot_assets:", error);
      return {};
    }
  };
  const handleProgressChange = (event) => {
    if (!progressBarRef.current) return;

    const { left, width } = progressBarRef.current.getBoundingClientRect();
    const clickX = event.clientX - left;
    const rawProgress = (clickX / width) * 100;

    // Find the closest step value
    const closestStep = steps.reduce((prev, curr) =>
      Math.abs(curr - rawProgress) < Math.abs(prev - rawProgress) ? curr : prev
    );

    setProgress(closestStep);
    handleSliderChange(closestStep);
  };

  const handleSliderInteraction = (event) => {
    if (!sliderRef.current) return;

    const { left, width } = sliderRef.current.getBoundingClientRect();
    const clickX = event.clientX - left;
    const rawProgress = (clickX / width) * 100;

    // Find the closest step value
    const closestStep = steps.reduce((prev, curr) =>
      Math.abs(curr - rawProgress) < Math.abs(prev - rawProgress) ? curr : prev
    );

    setSliderValue(closestStep);
    getSellSliderValLimit(closestStep);
  };

  const validateLimit = () => {
    // const minAmount = 0.0001;
    // const minPrice = 0.00000001;
    // if (limitAmount <= minAmount || limitPrice <= minPrice) {
    //   setError(true);
    // } else {
    //   setError(false);
    // }
  };

  const resetSlider = () => {
    setSliderValue(0);
    setProgress(0);
  };
  const calculateLimitTotalFromAmount = () => {
    const total = (limitAmount * limitPrice).toFixed(tradep);
    setLimitValue(isNaN(total) ? "" : total);
  };

  const getBuyVal = (event) => {
    const val = event.target.value;
    resetSliderBuy();

    // document.getElementById("customRange3")?.classList.remove("changeBackgroundSlider");

    if (val === "" || isNaN(val) || parseFloat(val) < 0) {
      showToast("warning", "Amount cannot be negative or blank");
      setLimitAmount("");
      setLimitValue(0);
      // document.getElementById("mbuy").disabled = true;
      return;
    }
    if (val < minBuySellAmount?.minBuyQty) {
      showToast(
        "warning",
        `The amount must be at least ${minBuySellAmount?.minBuyQty}`
      );
      setLimitValue(0);
      // document.getElementById("mbuy").disabled = true;
      return;
    }

    axios
      .get(
        `https://stream.paybito.com/SocketStream/api/depth?symbol=${currencycode}${basecurrency}&limit=1`
      )
      .then((response) => {
        const result = response.data;
        const price = parseFloat(result.ask[0].price);
        if (price) {
          const amount = parseFloat(val);

          if (isNaN(price) || isNaN(amount)) {
            setLimitPrice(0);
            setLimitValue(0);
            // document.getElementById("mbuy").disabled = true;
            return;
          }

          const totalPrice = (price * amount).toFixed(tradep);

          setLimitPrice((price - price * 0.01).toFixed(tradep));
          setLimitValue(totalPrice);
          // document.getElementById("mbuy").disabled = parseFloat(totalPrice) < 0.001;
        } else {
          setLimitPrice(0);
          setLimitValue(0);
          // document.getElementById("mbuy").disabled = true;
        }
      })
      .catch((error) => {
        console.error("Error fetching trade data", error);
        setLimitPrice(0);
        setLimitValue(0);
        // document.getElementById("mbuy").disabled = true;
      });
  };

  const getSellVal = async (event) => {
    let val = event.target.value;
    const regex = new RegExp(`^\\d*\\.?\\d{0,${tradep}}$`);

    resetSliderSell();

    if (val < 0 || val === "") {
      showToast("warning", "Amount cannot be negative or blank");
      setLimitAmountSell("");
      return;
    }
    if (val < minBuySellAmount?.minSellQty) {
      showToast(
        "warning",
        `The amount must be at least ${minBuySellAmount?.minSellQty}`
      );
      setLimitValueSell(0);
      // document.getElementById("mbuy").disabled = true;
      return;
    }

    try {
      const response = await axios.get(
        `https://stream.paybito.com/SocketStream/api/depth?symbol=${currencycode}${basecurrency}&limit=1`
      );
      const result = response.data;
      const price = parseFloat(result?.bid[0].price);

      if (price) {
        const amount = parseFloat(val);

        if (isNaN(price) || isNaN(amount)) {
          setLimitPriceSell(0);
          setLimitValueSell(0);
          // document.getElementById("mbuy").disabled = true;
          return;
        }
        const totalPrice = (price * amount).toFixed(tradep);

        setLimitPriceSell((price + price * 0.01).toFixed(tradep));
        setLimitValueSell(totalPrice);

        if (result?.message == "Order not found.") {
          showToast("error", "Order book depth reached. Order not found.");
          setLimitAmountSell(0);
        }
      } else {
        setLimitAmountSell(0);
        setLimitPriceSell(0);
      }
    } catch (error) {
      console.error("Error fetching sell data", error);
    }
  };

  const calculateAmountFromLimitForLimit = (type) => {
    if (type === "buy") {
      const value = (parseFloat(limitAmount) * parseFloat(limitPrice)).toFixed(
        tradep
      );
      setLimitValue(isNaN(value) ? "" : value);
      resetSliderBuy();
    } else if (type === "sell") {
      const valueSell = (
        parseFloat(limitAmountSell) * parseFloat(limitPriceSell)
      ).toFixed(tradep);
      setLimitValueSell(isNaN(valueSell) ? "" : valueSell);
      resetSliderSell();
    }
  };
  const resetSliderBuy = () => {
    setProgress(0);
  };
  const resetSliderSell = () => {
    setSliderValue(0);
  };

  const calculateAmountFromTotalForLimit = async (type, e) => {
    let inputValue = e.target.value;
    if (type === "buy") {
      setLimitValue(inputValue);
    } else {
      setLimitValueSell(inputValue);
    }

    try {
      const response = await axios.get(
        `https://stream.paybito.com/SocketStream/api/depth?symbol=${currencycode}${basecurrency}&limit=1`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      const data = response.data;
      let price, amount;

      if (type === "buy") {
        price = (parseFloat(data.ask[0].price) * 0.99).toFixed(8);
        amount = (parseFloat(inputValue) / parseFloat(price)).toFixed(8);
        // setLimitValue(inputValue);
        setLimitPrice(price);
        setLimitAmount(isNaN(amount) ? "" : amount);
        // setIsButtonDisabled(isNaN(amount) || parseFloat(amount) < 0.0001);
        resetSliderBuy();
      } else {
        price = (parseFloat(data.bid[0].price) * 1.01).toFixed(8);
        amount = (parseFloat(inputValue) / parseFloat(price)).toFixed(8);
        // setLimitValueSell(inputValue);
        setLimitPriceSell(price);
        setLimitAmountSell(isNaN(amount) ? "" : amount);
        // setIsButtonDisabled(isNaN(amount) || parseFloat(amount) < 0.0001);
        resetSliderSell();
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSliderChange = async (sliderValue) => {
    setLoading(true);

    let newBalanceLimit = parseFloat(selectedSellingAssetBalance);
    const buyingCrypto = currencycode;
    const sellingCrypto = basecurrency;
    const accessToken = localStorage.getItem("access_token");

    try {
      const response = await axios.get(
        `https://stream.paybito.com/SocketStream/api/depth?symbol=${currencycode}${basecurrency}&limit=1`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${accessToken}`,
          },
        }
      );
      const askPrice = parseFloat(response.data.ask[0].price);

      const calculatedLimitAmount = (
        (newBalanceLimit * (sliderValue / 100) -
          newBalanceLimit * (sliderValue / 100) * percentageValue) /
        askPrice
      ).toFixed(tradep);
      setLimitAmount(calculatedLimitAmount);

      if (sliderValue === 0) {
        setLimitPrice(0);
      } else {
        setLimitPrice((askPrice - askPrice * 0.01).toFixed(tradep));
      }
      setLimitValue(
        (calculatedLimitAmount * (askPrice - askPrice * 0.01)).toFixed(tradep)
      );
    } catch (error) {
      console.error("Error fetching market depth:", error);
    } finally {
      setLoading(false);
    }
  };

  const limitBuy = async () => {
    setIsLoading(true);

    const accreditationResult = await checkCurrencyPairAccreditedStatus(
      localStorage.getItem("userId"),
      currencycode?.toUpperCase(),
      basecurrency?.toUpperCase(),
      "BUY",
      limitAmount
    );

    if (!accreditationResult.accessAllowed) {
      setIsLoading(false);
      setShowAccreditedPopup(true);
      return;
    }

    const proceed = async () => {
      await doLimitBuy();
    };

    if (accreditationResult.requiresTermsAgreement) {
      setIsLoading(false);
      setTermsLinks(accreditationResult.links || []);
      setPendingProceed(() => proceed);
      setPendingTxnType(1);
      setShowTermsPopup(true);
      return;
    }

    await proceed();
  };

  const doLimitBuy = async () => {
    setIsLoading(true);

    if (limitPrice * limitAmount > 0) {
      if (limitAmount && limitPrice) {
        const tradeObj = {
          selling_asset_code: basecurrency.toUpperCase(),
          buying_asset_code: currencycode.toUpperCase(),
          amount: limitAmount,
          price: limitPrice,
          txn_type: "1",
          offerType:
            selectedOrderType === "FOK" || selectedOrderType === "IOC"
              ? "M"
              : "L",
          orderType:
            selectedOrderType !== "GTC" ? selectedOrderType : undefined,
          assetCode: getAssetCode(currencycode, basecurrency),
          baseCurrencyId: getAssetId(currencycode, basecurrency)
            ?.baseCurrencyId,
          currencyId: getAssetId(currencycode, basecurrency)?.currencyId,
          uuid: localStorage.getItem("uuid"),
        };

        try {
          const response = await fetch(
            `${WEBSERVICE}userTrade/TradeCreateOffer`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                authorization: `BEARER ${localStorage.getItem("access_token")}`,
              },
              body: JSON.stringify(tradeObj),
            }
          );

          const result = await response.json();
          setIsLoading(false);

          if (result.error.error_data !== 0) {
            if (result.error.error_data === 2) {
              showErrorDialog(result);
            } else {
              showToast("error", result.error.error_msg);
            }
          } else {
            showToast("success", result.error.error_msg);
            setLimitPrice("");
            setLimitAmount("");
            setLimitValue("");
            setProgress(0);
            getUserTransaction();

            switch (localStorage.getItem("tradeNavHist")) {
              case "open":
                renderDataForMyOfferSpot();
                break;
              case "stop":
                renderDataForStopLimitSpot("buy");
                break;
              default:
                localStorage.setItem("isTimeToRenderSpotMyTrade", "true");
            }
          }
        } catch (error) {
          showToast("error", "Trade request failed");
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
        showToast("warning", "Please provide proper buying details");
      }
    } else {
      setIsLoading(false);
      showToast("warning", "Your offer is too small");
    }

    // setLimitPrice(null);
    // setLimitAmount(null);
    setIsLoading(false);
  };

  const renderDataForMyOfferSpot = async () => {
    try {
      const response = await fetch(
        `https://stream.paybito.com/StreamingApi/rest/getOfferByAccountIDRest?userID=${localStorage.getItem(
          "userId"
        )}&buyingAssetCode=${selectedBuyingAssetBalance.toLowerCase()}&sellingAssetCode=${selectedSellingAssetBalance.toLowerCase()}&pageNo=1&noOfItemsPerPage=10`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );
      const result = await response.json();
      setSpotMyOfferData(result.tradeListResult);
    } catch (error) {
      if (error.error?.error === "invalid_token") {
        //logout
      } else {
        showToast("error", "Could Not Connect To Server");
      }
    }
  };

  const logout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  const renderDataForStopLimitSpot = async (param) => {
    let transactionType = param === "buy" ? "1" : "2";
    const payload = {
      uuid: localStorage.getItem("uuid"),
      buying_asset_code:
        param === "buy"
          ? currencycode.toUpperCase()
          : basecurrency.toUpperCase(),
      selling_asset_code:
        param === "buy"
          ? basecurrency.toUpperCase()
          : currencycode.toUpperCase(),
      txn_type: transactionType,
    };

    try {
      const response = await fetch(
        `${WEBSERVICE}userTrade/GetStopLossBuySell`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify(payload),
        }
      );
      const result = await response.json();
      if (param === "buy") {
        setSpotSpotLimitBuyData(result.stopLossList);
      } else {
        setSpotSpotLimitSellData(result.stopLossList);
      }
    } catch (error) {
      if (error.error?.error === "invalid_token") {
        //logout
      } else {
        showToast("error", "Could Not Connect To Server");
      }
    }
  };

  const validateLimitSell = () => {
    // const lv = 0.000001;
    // const isInvalid = limitAmountSell <= 0.0001 || limitPriceSell <= 0.00000001;
    // setError(isInvalid);
    // return isInvalid;
  };

  const calculateLimitTotalFromAmountSell = () => {
    const total = (limitAmountSell * limitPriceSell).toFixed(tradep);
    setLimitValueSell(isNaN(total) ? "" : total);
  };

  const getSellSliderValLimit = async (newSliderValue) => {
    setStpLoader(true);

    // let sliderElement = document.getElementById("customRange4");
    // if (value === 4) {
    //   sliderElement.classList.add("changeBackgroundSlider");
    // } else {
    //   sliderElement.classList.remove("changeBackgroundSlider");
    // }

    let newSellBalanceLimit = parseFloat(selectedBuyingAssetBalance);
    let limitAmountSell = newSellBalanceLimit * (newSliderValue / 100);

    try {
      const response = await axios.get(
        `https://stream.paybito.com/SocketStream/api/depth?symbol=${currencycode}${basecurrency}&limit=1`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      let bidPrice = parseFloat(response.data.bid[0].price);
      let calculatedLimitPriceSell =
        newSliderValue === 0 ? 0 : (bidPrice + bidPrice * 0.01).toFixed(tradep);
      setLimitAmountSell(limitAmountSell);
      setLimitPriceSell(calculatedLimitPriceSell);
      setLimitValueSell(
        (limitAmountSell * calculatedLimitPriceSell).toFixed(tradep)
      );
      validateLimitSell();
    } catch (error) {
      console.error("Error fetching bid price", error);
    }

    setStpLoader(false);
  };

  const handleLimitSell = async () => {
    if (!limitPriceSell || !limitAmountSell) {
      showToast("warning", "Please provide proper selling details");
      return;
    }

    if (limitPriceSell * limitAmountSell < limitValueSell) {
      showToast("warning", "Your offer is too small");
      return;
    }

    setLoader(true);
    const accreditationResult = await checkCurrencyPairAccreditedStatus(
      localStorage.getItem("userId"),
      basecurrency?.toUpperCase(),
      currencycode?.toUpperCase(),
      "SELL",
      limitAmountSell
    );

    if (!accreditationResult.accessAllowed) {
      setIsLoading(false);
      setLoader(false);
      setShowAccreditedPopup(true);
      return;
    }

    const proceed = async () => {
      await doLimitSellCore();
    };

    if (accreditationResult.requiresTermsAgreement) {
      setIsLoading(false);
      setLoader(false);
      setTermsLinks(accreditationResult.links || []);
      setPendingProceed(() => proceed);
      setPendingTxnType(2);
      setShowTermsPopup(true);
      return;
    }

    await proceed();
  };

  const doLimitSellCore = async () => {
    setLoader(true);
    const inputObj = {
      selling_asset_code: currencycode.toUpperCase(),
      buying_asset_code: basecurrency.toUpperCase(),
      userId: localStorage.getItem("userId"),
      amount: limitAmountSell,
      price: limitPriceSell,
      txn_type: "2",
      offerType:
        selectedOrderType === "FOK" || selectedOrderType === "IOC" ? "M" : "L",
      assetCode: getAssetCode(currencycode, basecurrency),
      baseCurrencyId: getAssetId(currencycode, basecurrency)["baseCurrencyId"],
      currencyId: getAssetId(currencycode, basecurrency)["currencyId"],
      uuid: localStorage.getItem("uuid"),
      orderType: selectedOrderType !== "GTC" ? selectedOrderType : undefined,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}userTrade/TradeCreateOffer`,
        inputObj,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      setLoader(false);
      if (response.data.error.error_data !== 0) {
        if (response.data.error.error_data === 2) {
          showErrorDialog(response.data);
        } else {
          showToast("error", response.data.error.error_msg);
        }
      } else {
        showToast("success", response.data.error.error_msg);
        localStorage.setItem("isTimeToRenderSpotMyTrade", "true");
        renderDataForMyOfferSpot();
        setLimitAmountSell("");
        setLimitPriceSell("");
        setLimitValueSell("");
        setSliderValue(0);
        getUserTransaction();
      }
    } catch (error) {
      setLoader(false);
      showToast("error", "Something went wrong");
    }
  };

  return (
    <div>
      <div className="trade-wrap">
        {/* ── BUY Panel ── */}
        <div className="trade-panel trade-panel-buy">
          <div className="trade-side-label buy-label">
            BUY {currencycode?.toUpperCase()}
          </div>
          <div className="trade-bal-row">
            <span>Available</span>
            <span>
              {selectedSellingAssetBalance} {basecurrency?.toUpperCase()}
            </span>
          </div>

          <div className="trade-input-group">
            <label>Amount</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder="0"
                value={limitAmount}
                onChange={(e) => {
                  const value = e.target.value;
                  const regex = new RegExp(`^\\d*\\.?\\d{0,${tradep}}$`);
                  if (regex.test(value)) {
                    setLimitAmount(value);
                  }
                }}
                onKeyUp={(e) => {
                  validateLimit();
                  resetSliderBuy();
                  calculateLimitTotalFromAmount();
                  getBuyVal(e);
                }}
              />
              <span className="trade-unit">{currencycode?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-input-group">
            <label>Price (Best)</label>
            <div className="trade-input-box">
              <input
                type="number"
                value={limitPrice}
                onChange={(e) => setLimitPrice(e.target.value)}
                onKeyUp={() => {
                  validateLimit();
                  calculateAmountFromLimitForLimit("buy");
                }}
                placeholder="0"
                readOnly
                style={{ background: "var(--body-color-less2)" }}
              />
              <span className="trade-unit">{basecurrency?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-input-group">
            <label>Total</label>
            <div className="trade-input-box">
              <input
                type="number"
                value={limitValue}
                onChange={(e) => calculateAmountFromTotalForLimit("buy", e)}
                placeholder="0"
                name="lval"
              />
              <span className="trade-unit">{basecurrency?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-pct-row" ref={progressBarRef}>
            {[25, 50, 75, 100].map((pct) => (
              <button
                key={pct}
                className={`trade-pct-btn${progress === pct ? " pct-active-buy" : ""
                  }`}
                onClick={() => {
                  setProgress(pct);
                  handleSliderChange(pct);
                }}
              >
                {pct}%
              </button>
            ))}
          </div>

          <button
            className="trade-action-btn btn-buy"
            disabled={
              !(limitValue > 0) ||
              isLoading ||
              Number(limitAmount) < Number(minBuySellAmount?.minBuyQty)
            }
            onClick={limitBuy}
          >
            {isLoading ? "Placing..." : `BUY ${currencycode?.toUpperCase()}`}
          </button>
        </div>

        {/* ── SELL Panel ── */}
        <div className="trade-panel">
          <div className="trade-side-label sell-label">
            SELL {currencycode?.toUpperCase()}
          </div>
          <div className="trade-bal-row">
            <span>Available</span>
            <span>
              {selectedBuyingAssetBalance} {currencycode?.toUpperCase()}
            </span>
          </div>

          <div className="trade-input-group">
            <label>Amount</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder="0"
                value={limitAmountSell}
                onChange={(e) => {
                  const value = e.target.value;
                  const regex = new RegExp(`^\\d*\\.?\\d{0,${tradep}}$`);
                  if (regex.test(value)) {
                    setLimitAmountSell(value);
                  }
                }}
                onKeyUp={(e) => {
                  validateLimitSell();
                  resetSliderSell();
                  calculateLimitTotalFromAmountSell();
                  getSellVal(e);
                }}
              />
              <span className="trade-unit">{currencycode?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-input-group">
            <label>Price (Best)</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder="0"
                value={limitPriceSell}
                onChange={(e) => setLimitPriceSell(e.target.value)}
                onKeyUp={() => {
                  validateLimitSell();
                  calculateAmountFromLimitForLimit("sell");
                }}
                readOnly
                style={{ background: "var(--body-color-less2)" }}
              />
              <span className="trade-unit">{basecurrency?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-input-group">
            <label>Total</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder="0"
                value={limitValueSell}
                onChange={(e) => calculateAmountFromTotalForLimit("sell", e)}
              />
              <span className="trade-unit">{basecurrency?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-pct-row" ref={sliderRef}>
            {[25, 50, 75, 100].map((pct) => (
              <button
                key={pct}
                className={`trade-pct-btn${sliderValue === pct ? " pct-active-sell" : ""
                  }`}
                onClick={() => {
                  setSliderValue(pct);
                  getSellSliderValLimit(pct);
                }}
              >
                {pct}%
              </button>
            ))}
          </div>

          <button
            className="trade-action-btn btn-sell"
            disabled={
              !(limitValueSell > 0) ||
              loader ||
              Number(limitAmountSell) < Number(minBuySellAmount?.minSellQty)
            }
            onClick={handleLimitSell}
          >
            {loader ? "Placing..." : `SELL ${currencycode?.toUpperCase()}`}
          </button>
        </div>
      </div>

      <InfoPopUp
        open={show}
        onClose={handleClose}
        title={title}
        description={description}
      />
      <AccreditationVerificationPopup
        open={showAccreditedPopup}
        onClose={() => setShowAccreditedPopup(false)}
        theme={localStorage.getItem("theme")}
      />
      <TermsAgreementPopup
        open={showTermsPopup}
        onClose={() => {
          setShowTermsPopup(false);
          setPendingProceed(null);
        }}
        onProceed={() => {
          if (typeof pendingProceed === "function") {
            pendingProceed();
          }
          setPendingProceed(null);
        }}
        links={termsLinks}
        theme={localStorage.getItem("theme")}
        vestingCurrency={currencycode}
        txnType={pendingTxnType}
      />
    </div>
  );
};

export default BuyAndSellIOC;
